import * as React from 'react'
import styled from 'styled-components'

const Main = styled.div`
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: flex-start;

	div {
		background-color: #0E0E11;
		width: 80%;
		max-width: 600px;
		padding: 16px 32px;
		margin-top: 6em;
		font-family: 'PT Mono';
		box-shadow: 0px 0px 28px rgba(0,0,0,.8);
		border-radius: 15px;
	}

	p {
		color: #888;
		font-size: 1.125em;
		line-height: 1.5;
	}

	span {
		display: block;
		text-align: center;
		font-size: 2em;
		line-height: 1.25;
		margin-top: 16px;
	}
`

const NotFound = () => (
	<Main>
		<div>
			<p>Fear not, for you are found. You are home, and there is no going back. No one leaves this place. But what is this place? The answer is ... <span>The 404 Page</span></p>
		</div>
	</Main>
)

export default NotFound
